import { Card, Row, Tooltip, notification } from 'antd'
import React from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import Heading from '../../../../../component/common/Heading'
import CRUDComponent from '../../../../../component/common/CRUD-Component'
import CONSTANTS from '../../../../../util/constant/CONSTANTS'
import { convertUTCToLocal } from '../../../../../util/functions'
import { CopyOutlined } from '@ant-design/icons';
import BackButton from '../../../../../component/common/Back-Button'
const ErrorLog = () => {
    const { deviceId } = useParams();
    const navigate = useNavigate()
    const copyHandler = (id) => {
        try {
            window.navigator.clipboard.writeText(id)
            notification.success({ message: 'Unique Id Copied' })

        } catch (error) {
            notification.error({ message: 'Something went wrong' })
        }
    }
    return (
        <>
            <div>
                <Card className="my-5">
                    <BackButton onClick={() => navigate(-1)} />
                    <Heading>Collar Error Logs</Heading>
                    <Row>
                        <CRUDComponent
                            GET={{
                                API: CONSTANTS.API.Device_Error.getAll,
                                extraQuery: {
                                    deviceId
                                },
                                DataModifier: (res, API, Setrefresh) => {
                                    // console.log(res, "GET ALL ABCD");
                                    return res?.map(data => {
                                        return {
                                            ...data,
                                            no: `DE${data?.id.toString().padStart(7, "0")}`,
                                            timeStampD: data?.timeStamp ? convertUTCToLocal(data?.timeStamp, 'DD MMM, YYYY hh:mm A') : '',
                                            uniqueIdD: <div> {data?.device?.uniqueId} <Tooltip title="Copy Unique Id"> <CopyOutlined onClick={() => {
                                                copyHandler(data?.device?.uniqueId)
                                            }} /></Tooltip> </div> || '-',


                                        }
                                    })
                                },
                                column: CONSTANTS.TABLE.DEVICE_ERROR_LOG,
                            }}
                            isSearch
                        />
                    </Row>
                </Card>
            </div>
        </>
    )
}

export default ErrorLog